import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container, Stack, Typography, useTheme } from '@mui/material';

import ShieldIcon from '@/assets/icons/shield.svg?react';
import { ROUTER_PATHS } from '@/root/linker';

const ErrorAccessDenied = () => {
  const { t } = useTranslation('common');
  const { palette } = useTheme();

  // Note: We don't use useNavigate here because we want to reload the page AND it's not accessible in root context.
  const handleGoHome = useCallback(() => {
    window.location.href = ROUTER_PATHS.HOME;
  }, []);

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8, textAlign: 'center' }}>
      <Stack
        spacing={3}
        alignItems="center"
        sx={{
          '& .ShieldIcon-root': {
            width: 64,
            height: 64,
            color: palette.error.main
          }
        }}
      >
        <ShieldIcon className="ShieldIcon-root" />
        <Typography variant="h4" component="h1" gutterBottom>
          {t('error.accessDenied')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('error.accessDeniedMessage')}
        </Typography>
        <Button variant="contained" color="primary" onClick={handleGoHome}>
          {t('error.goToHome')}
        </Button>
      </Stack>
    </Container>
  );
};

export default ErrorAccessDenied;
